import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const res = await fetch('/api/admin/check', { credentials: 'include' });
      const data = await res.json();
      if (data.authenticated) {
        navigate('/admin/dashboard');
      }
    } catch (e) {}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        credentials: 'include'
      });
      const data = await res.json();
      if (data.success) {
        navigate('/admin/dashboard');
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Connection error');
    }
  };

  return (
    <>
      <div className="admin-page">
        <Container>
          <Row className="justify-content-center">
            <Col md={5}>
              <Card className="admin-card">
                <Card.Body className="p-5">
                  <h2 className="admin-title">6G AI Admin</h2>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <label className="form-label">Username</label>
                      <input
                        type="text"
                        className="form-control"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    {error && <div className="alert alert-error">{error}</div>}
                    <button type="submit" className="btn btn-primary w-100">
                      Login
                    </button>
                  </form>
                  <div className="text-center mt-4">
                    <Link to="/" className="admin-link">← Back to Website</Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <style>{`
        .admin-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--md-sys-color-surface);
          padding: var(--space-xl) 0;
        }
        
        .admin-card {
          background: var(--md-sys-color-surface-container);
          border: 1px solid var(--md-sys-color-outline-variant);
          border-radius: var(--radius-extra-large);
          box-shadow: var(--md-sys-elevation-4);
        }
        
        .admin-title {
          text-align: center;
          margin-bottom: var(--space-xl);
          color: var(--md-sys-color-primary);
          font-weight: 700;
          font-size: var(--font-headline-sm);
        }
        
        .admin-link {
          color: var(--md-sys-color-on-surface-variant);
          transition: color var(--motion-duration-short2) var(--motion-easing-standard);
        }
        
        .admin-link:hover {
          color: var(--md-sys-color-primary);
        }
        
        .alert-error {
          background: var(--md-sys-color-error-container);
          color: var(--md-sys-color-on-error-container);
          padding: var(--space-md);
          border-radius: var(--radius-medium);
          margin-bottom: var(--space-md);
          font-size: var(--font-body-sm);
        }
      `}</style>
    </>
  );
}

export default AdminLogin;
